/**
 * v4.8.2 — Launch Guided Demo button.
 *
 * Visible ONLY when Master Demo Mode is active. Outside Demo Mode this
 * component renders nothing — there is no entry point to the Guided
 * Demo from a normal operating session.
 *
 * Clicking starts the Blue Flame tour overlay (DemoContext). The user
 * can close the overlay at any time and remain inside Demo Mode for
 * free exploration.
 */
import React from "react";
import { useTranslation } from "react-i18next";
import { PlayCircle } from "lucide-react";
import { useDemoMode } from "../demoMode/DemoModeContext";
import { useDemo } from "./DemoContext";

export const LaunchGuidedDemoButton = ({ personaKey = "blue_flame" }) => {
    const { t } = useTranslation();
    const { active: demoModeActive, loaded } = useDemoMode();
    const { start, isActive: tourActive } = useDemo();

    // Render gates:
    // 1. Master Demo Mode must be active.
    // 2. Tour must not already be running (avoid double-launch).
    // 3. Wait for the demo-mode state to load to avoid flicker.
    if (!loaded || !demoModeActive || tourActive) return null;

    return (
        <button
            type="button"
            onClick={() => start(personaKey, "interactive")}
            data-testid="ob-launch-guided-demo"
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm transition-colors mb-2"
            style={{
                color: "#A7F3D0",
                background: "linear-gradient(90deg, rgba(16,185,129,0.14) 0%, rgba(16,185,129,0.05) 100%)",
                border: "1px solid rgba(16,185,129,0.28)",
            }}
        >
            <PlayCircle size={16} strokeWidth={1.5} aria-hidden="true" />
            <span className="truncate flex-1 text-left">
                {t("ob.tour.launch_in_demo")}
            </span>
        </button>
    );
};

export default LaunchGuidedDemoButton;
